import {useCallback} from 'react';
import {useLayoutContext} from '../components/LayoutContextProvider';

export const useOverlay = () => {
  const {openOverlay} = useLayoutContext();
  return useCallback((value) => openOverlay(value), [openOverlay]);
};
